export const OtherExWarehouseRouting = [
  {
    path: "/material/otherExWarehouse/list",
    name: "basic-material-other-ex-warehouse-list",
    meta: { title: "自定义出库申请" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-ex-warehouse/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherExWarehouse/create",
    name: "basic-material-other-ex-warehouse-create",
    meta: { title: "新增自定义出库申请", comName: "BasicMaterialOtherExWarehouseCreate" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-ex-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherExWarehouse/edit/:id",
    name: "basic-material-other-ex-warehouse-edit",
    meta: { title: "编辑自定义出库申请", comName: "BasicMaterialOtherExWarehouseCreate" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-ex-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherExWarehouse/flowPrint/:id",
    name: "basic-material-other-ex-warehouse-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-ex-warehouse/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherExWarehouse/detail/:id",
    name: "basic-material-other-ex-warehouse-detail",
    meta: { title: "自定义出库申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-ex-warehouse/form-detail/index.vue"
      ),
  },
];
